import { render, staticRenderFns } from "./OverlaySlidesComponent.vue?vue&type=template&id=74c6bd1e&scoped=true&"
import script from "./OverlaySlidesComponent.vue?vue&type=script&lang=js&"
export * from "./OverlaySlidesComponent.vue?vue&type=script&lang=js&"
import style0 from "./OverlaySlidesComponent.vue?vue&type=style&index=0&id=74c6bd1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c6bd1e",
  null
  
)

export default component.exports